import axios from "axios";

import { config } from "~/data";

import type { OlympicEvents } from "./types";

export const fetchEvents = async () => {
  const pathname = `${config.olympic.apiHost}/data`;

  try {
    const [china, hk] = await axios.all([
      axios.get<OlympicEvents[]>(`${pathname}/olympic-2024-events-china.json`),
      axios.get<OlympicEvents[]>(`${pathname}/olympic-2024-events-hk.json`),
    ]);
    return {
      china: china.data,
      hk: hk.data,
    };
  } catch {
    return {
      china: [],
      hk: [],
    };
  }
};
